/* Ultrabling: phone colour helpers outside the product page.
   - Cart drawer and cart page: show the mockup in the colour saved in "_Phone colour".
   - iPhone 18 series page (#ub18): save the chosen colour on the case and remember it
     for product pages (localStorage "ubPhoneColour", shared with ub-phone-colour.js). */
(function () {
  if (window.__ubCartColour) return;
  window.__ubCartColour = true;

  var STORE_KEY = 'ubPhoneColour';
  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeStore(series, id) {
    try { var s = readStore(); s[series] = id; localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  /* ---------- iPhone 18 series page (#ub18): save the colour on the case, remember it ---------- */
  var UB18 = { burgundy: 'Burgundy', glacier: 'Glacier', black: 'Black', silver: 'Silver' };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#ub18 [data-act="color"]');
    if (b && UB18[b.getAttribute('data-v')]) writeStore('18', b.getAttribute('data-v'));
  }, true);
  if (document.getElementById('ub18') && window.fetch && !window.fetch.__ub18) {
    var origFetch = window.fetch;
    var ub18Fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add\.js/.test(url) && init && typeof init.body === 'string') {
          var body = JSON.parse(init.body);
          var caseOn = document.querySelector('#ubSet [data-act="tog"][data-v="case"][aria-pressed="true"]');
          var sw = document.querySelector('#ubSw [data-act="color"][aria-pressed="true"]');
          var name = sw && UB18[sw.getAttribute('data-v')];
          if (caseOn && name && body.items && body.items[0] && !body.items[0].properties) {
            body.items[0].properties = { '_Phone colour': name };
            init = Object.assign({}, init, { body: JSON.stringify(body) });
          }
        }
      } catch (e) {}
      return origFetch.call(this, input, init);
    };
    ub18Fetch.__ub18 = true;
    window.fetch = ub18Fetch;
  }

  /* ---------- Cart: show the mockup in the colour the customer picked ---------- */
  var productCache = {};
  function productJson(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  function sized(src, w) {
    return src.replace(/^https?:/, '') + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var cartBusy = false;
  function fixCartImages() {
    if (cartBusy) return;
    var rows = document.querySelectorAll('[id^="CartDrawer-Item-"], [id^="CartItem-"]');
    if (!rows.length) return;
    cartBusy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var jobs = (cart.items || []).map(function (item) {
          var colour = item.properties && item.properties['_Phone colour'];
          if (!colour) return null;
          var model = (item.variant_options && item.variant_options[0] || '').replace(/\s*Max$/i, '').trim();
          var needle = (' on ' + model + ' ' + colour).toLowerCase();
          return productJson(item.handle).then(function (p) {
            if (!p || !p.media) return;
            var m = p.media.find(function (x) { return (x.alt || '').toLowerCase().indexOf(needle) > -1; });
            if (!m) return;
            var src = m.src || (m.preview_image && m.preview_image.src);
            if (!src) return;
            ['CartDrawer-Item-' + item.key, 'CartItem-' + item.key].forEach(function (id) {
              var row = document.getElementById(id);
              var img = row && row.querySelector('img');
              if (!img || img.getAttribute('data-ub-pc-src') === src) return;
              img.setAttribute('data-ub-pc-src', src);
              img.removeAttribute('srcset');
              img.src = sized(src, 360);
            });
          });
        }).filter(Boolean);
        return Promise.all(jobs);
      })
      .catch(function () {})
      .then(function () { cartBusy = false; });
  }
  var cartTimer = null;
  function scheduleCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(fixCartImages, 60);
  }
  function watchCart() {
    ['CartDrawer', 'cart'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || el.__ubCartWatched) return;
      el.__ubCartWatched = true;
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].target.closest && list[i].target.closest('[data-ub-pc-src]')) continue;
          if (list[i].addedNodes.length) { scheduleCart(); break; }
        }
      }).observe(el, { childList: true, subtree: true });
    });
    scheduleCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart);
  else watchCart();
  document.addEventListener('shopify:section:load', watchCart);
})();